export default "__VITE_ASSET__29acc509__"